import React, { Component } from 'react';


import { make_cols } from './MakeColumns';

import './styles.css';

class UploadButtonAltVendor extends Component {

    constructor(props) {
        super(props);
        this.state = {
          file: {},
          data: [],
          cols: []
        }
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
      }

    handleChange = (e) => {
        this.props.openNotification(true);
        const files = e.target.files;
        if (files && files[0]) {
            this.setState({ file: files[0] });
            setTimeout(() => { this.handleFile(); }, 2000);
        }
        e.target.value = null;
    };
     
    handleFile() {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
     
        reader.onload = async (e) => {

          const XLSX = await import("xlsx");
          
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          /* Update state */
          this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
          const excelJson = JSON.parse(JSON.stringify(this.state.data));
          const moqObject = excelJson.map(({ "sku": sku, "altVendorNumber": altVendorNumber, "warehouses": warehouses, "nipoBaseCost": nipoBaseCost, 
          "nipoCoreCost": nipoCoreCost, "itemsAvailable": itemsAvailable, "itemsAnnaulCommitment": itemsAnnaulCommitment, "unitsPerCase": unitsPerCase, "casesPerTier": casesPerTier,
          "tiersPerPallet": tiersPerPallet, "companyPOQ": companyPOQ, "expirationDate": expirationDate, "remainingAvailable": remainingAvailable, "cancel": cancel, ...rest }) => 
          ({ sku, altVendorNumber, warehouses, nipoBaseCost, nipoCoreCost, itemsAvailable, itemsAnnaulCommitment, unitsPerCase, casesPerTier, tiersPerPallet, companyPOQ, expirationDate, remainingAvailable, cancel, ...rest }));
          this.props.onGetExcelData(moqObject);  
         });
        };
        if (rABS) {
          reader.readAsBinaryString(this.state.file);
        } else {
          reader.readAsArrayBuffer(this.state.file);
        };
    }

    buttonHandler = () => {
        document.getElementById('fileInput').click();
    }

    render() {
        return (
            <div>
                <input id="fileInput" type="file" className="input-file" accept=".xls, .xlsx" onChange={this.handleChange}/>
                <input type="button" value="Upload" onClick={this.buttonHandler} className="upload-button"/>
            </div>
        );
    }
 
}

export default UploadButtonAltVendor;